module.exports = __webpack_public_path__ + "static/media/erosao_fotos.d296c383.png";